import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from '../../../../components/CircularProgress';
import moment from 'moment';
import { toast } from 'react-toastify';
import Button from '@material-ui/core/Button';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from '@material-ui/core/Select';
import TextArea from 'antd/lib/input/TextArea';
import Switch from '@material-ui/core/Switch';
import {
    GetBSAccountsReconcile,
    UpdateCustomField,
    PUT_QuickbookAccount_UpdateAccountStatus,
    GetLastQuarterGLReviewedDate
} from "../../../../appRedux/actions/BalanceSheetAction";
import { AddQuestion } from "../../../../appRedux/actions/QuestionCommentsAction";
import { GetLastQuarterEndDate, getCompanyMaxDate, LinkType, numberWithCommas, makeLinkForQuickbooks } from "../../../common/commonServices";
import { QboSystemAccounts } from '../../../../constants/Enums';
import "./BSAccountsReconcile.css";

/**
 * Recursive tree rows (own class so expand/edit state works per nest level).
 */
class BSAccountsReconcileNode extends Component {

    constructor(props) {
        super(props);
        this.Reconciled = React.createRef();
        this.state = {
            lst_data: props.data || [],
            level: props.level,
            selectedlevel: -1,
            editedData: null,
            ExpandedList: []
        };
    }

    onRowUpdateClick = () => {
        this.props.UpdateFields(this.state.editedData);
    }

    onRowCancelClick = () => {
        this.setState({ selectedlevel: -1, editedData: null });
    }

    handleFormChange = (e, target) => {
        if (target === "ReconciledThrough") {
            const ed = this.state.editedData;
            ed.ReconciledThrough = e ? new Date(e) : null;
            ed.isReconciledThrough = true;
            this.setState({ editedData: ed });
        }
    }

    handleMessage = (event) => {
        const ed = this.state.editedData;
        ed.Notes = event.target.value;
        this.setState({ editedData: ed });
    }

    handleQuestion = (event) => {
        const ed = this.state.editedData;
        ed.question = event.target.value;
        this.setState({ editedData: ed });
    }

    showChild = (groupName, data) => {
        if (data.IsData) {
            const item = {
                AccountId: data.AccountId,
                ReconciledThrough: (data.ReconciledThrough === "" || data.ReconciledThrough == null)
                    ? null
                    : new Date(data.ReconciledThrough),
                Notes: data.Notes != null ? data.Notes : '',
                oldOutstandingCount: data.OldOutstandingCount,
                questionID: data.QuestionId,
                question: data.Question != null ? data.Question : ''
            };
            this.setState({ selectedlevel: data.AccountId, editedData: item });
            return;
        }

        const items = [...this.state.ExpandedList];
        if (this.IsExpanded(data.Account)) {
            items.splice(items.indexOf(data.Account), 1);
        } else {
            items.push(data.Account);
        }
        this.setState({
            ExpandedList: items,
            editedData: null,
            selectedlevel: -1
        });
    }

    handleFocus = (e, selecter) => {
        if (selecter !== undefined && this.Reconciled.current != null) {
            this.Reconciled.current.setFocus();
        }
    }

    componentDidMount() {
        const expandedData = [...this.state.ExpandedList];
        const accounts = this.state.lst_data || [];
        for (let i = 0; i < accounts.length; i++) {
            if (expandedData.indexOf(accounts[i].Account) < 0) {
                expandedData.push(accounts[i].Account);
            }
        }
        this.setState({ ExpandedList: expandedData });
    }

    IsExpanded = (accountName) => {
        return this.state.ExpandedList.indexOf(accountName) > -1;
    }

    onLinkClick = (item) => {
        const qboBaseUrl = makeLinkForQuickbooks();
        const url = `${qboBaseUrl}/app/register?accountId=${item.QboAccountId}`;
        window.open(url, '_blank');
    }

    updateAccountStatus = (e, item) => {
        this.props.accountStatusChange(e, item);
    }

    isSystemAccount = (name, type) => {
        if (!name && !type) return false;
        const systemAccounts = Object.values(QboSystemAccounts);
        const normalizedName = (name || "").toLowerCase().trim();
        const normalizedType = (type || "").toLowerCase().trim();
        return systemAccounts.some(acc =>
            acc.toLowerCase().trim() === normalizedName ||
            acc.toLowerCase().trim() === normalizedType
        );
    }

    getIndentPx = (level) => {
        return 20 + (Math.max((level || 1) - 1, 0) * 20);
    }

    getRowClassName = (item) => {
        if (item.IsHeader) {
            if (item.level <= 1) {
                const name = (item.Account || "").toUpperCase();
                if (name.indexOf("LIABILIT") >= 0 || name.indexOf("EQUITY") >= 0) {
                    return "bsar-section-header bsar-section-header-liability";
                }
                return "bsar-section-header";
            }
            return "bsar-type-header";
        }
        if (item.IsSummary) {
            if (item.level <= 1) {
                const name = (item.Account || "").toUpperCase();
                if (name.indexOf("LIABILIT") >= 0 || name.indexOf("EQUITY") >= 0) {
                    return "bsar-section-total bsar-section-total-liability";
                }
                return "bsar-section-total bsar-section-total-asset";
            }
            return "bsar-type-subtotal";
        }
        return "bsar-account-row";
    }

    formatBalance = (value) => {
        return "$" + numberWithCommas(value);
    }

    renderToggleIcon = (item) => {
        if (!item.IsHeader) {
            return null;
        }
        const expanded = this.IsExpanded(item.Account);
        return (
            <span className="bsar-parent-toggle">
                {expanded
                    ? <i className="zmdi zmdi-minus-circle-outline" style={{ color: "#349683" }}></i>
                    : <i className="zmdi zmdi-plus-circle-o" style={{ color: "#334c5a" }}></i>}
            </span>
        );
    }

    getSectionTotalRow = (item) => {
        if (!item.IsHeader || item.level > 1 || !item.Items || item.Items.length === 0) {
            return null;
        }
        const totalRow = item.Items[item.Items.length - 1];
        if (!totalRow || !totalRow.IsSummary) {
            return null;
        }
        return totalRow;
    }

    renderAccountRowCells = (item) => {
        const indent = this.getIndentPx(item.level);
        const toggleIcon = this.renderToggleIcon(item);
        const showSectionBalanceInHeader = !(item.IsHeader && item.level <= 1 && !this.IsExpanded(item.Account));

        if (item.IsHeader) {
            return (
                <React.Fragment>
                    <td className="bsar-account-name-col" style={{ paddingLeft: indent + "px" }}>
                        <span style={{ fontWeight: item.level <= 1 ? 700 : 500 }}>
                            {toggleIcon}{item.Account}
                        </span>
                    </td>
                    <td></td>
                    <td className="text-right">
                        {showSectionBalanceInHeader && item.Balance != 0 && <span>{this.formatBalance(item.Balance)}</span>}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </React.Fragment>
            );
        }

        if (item.IsSummary) {
            return (
                <React.Fragment>
                    <td className="bsar-account-name-col" style={{ paddingLeft: indent + "px", fontWeight: 700 }}>
                        {item.Account}
                    </td>
                    <td></td>
                    <td className="text-right" style={{ fontWeight: 700 }}>
                        {this.formatBalance(item.Balance)}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <td className="bsar-account-name-col" style={{ paddingLeft: indent + "px" }}>{item.Account}</td>
                <td>{item.Type}</td>
                <td className="text-right">{this.formatBalance(item.Balance)}</td>
                <td className="bsar-reconciled-col">{item.STRT}</td>
                <td className="fixed-col bsar-internal-notes-col">{item.Notes}</td>
                <td className="fixed-col bsar-questions-col">{item.Question}</td>
                <td className="bsar-make-inactive-col text-center">
                    {item.Balance == 0 && !this.isSystemAccount(item.Account, item.Type) && (
                        <Switch onClick={(e) => this.updateAccountStatus(e, item)} />
                    )}
                </td>
                <td className="text-center">
                    {(item.Balance != 0) && (
                        <img
                            alt="link"
                            src="/vendors/grrenLink.png"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.onLinkClick(item);
                            }}
                            style={{ cursor: "pointer" }}
                        />
                    )}
                </td>
            </React.Fragment>
        );
    }

    render() {
        const { UpdateFields, accountStatusChange } = this.props;
        const rows = this.state.lst_data || [];

        return (
            <React.Fragment>
                {rows.map((item, i) => (
                    <React.Fragment key={this.state.level + "_" + i}>
                        <tr
                            className={this.getRowClassName(item)}
                            onClick={() => this.showChild(item.Account, item)}
                        >
                            {this.renderAccountRowCells(item)}
                        </tr>
                        {!this.IsExpanded(item.Account) && (() => {
                            const totalRow = this.getSectionTotalRow(item);
                            if (!totalRow) {
                                return null;
                            }
                            return (
                                <tr className={this.getRowClassName(totalRow)}>
                                    {this.renderAccountRowCells(totalRow)}
                                </tr>
                            );
                        })()}
                        {this.state.selectedlevel == item.AccountId && this.state.editedData && (
                            <tr className="bs-edit-row">
                                <td colSpan="3">&nbsp;</td>
                                <td>
                                    <div>Reconciled Through</div>
                                    <div className="date-box" style={{ border: '1px solid rgb(225, 123, 64)', borderRadius: '6px' }}>
                                        <DatePicker
                                            selected={this.state.editedData.ReconciledThrough}
                                            onChange={(e) => this.handleFormChange(e, 'ReconciledThrough')}
                                            label="Loan Date"
                                            id="date"
                                            name="ReconciledThrough"
                                            margin="normal"
                                            disabledKeyboardNavigation
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            yearDropdownItemNumber={15}
                                            maxDate={new Date()}
                                            ref={this.Reconciled}
                                            portalId="bs-datepicker-portal"
                                            popperPlacement="bottom-start"
                                            popperModifiers={{
                                                flip: { enabled: true, behavior: ["bottom-start", "top-start"] },
                                                preventOverflow: { enabled: true, escapeWithReference: false, boundariesElement: "viewport" }
                                            }}
                                        />
                                        <div className="date-icon" onClick={(e) => this.handleFocus(e, 'ReconciledThrough')}>
                                            <i className="zmdi zmdi-calendar-note"></i>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    Internal Notes :
                                    <TextArea
                                        placeholder="Enter Notes"
                                        onChange={this.handleMessage}
                                        value={this.state.editedData.Notes != null ? this.state.editedData.Notes : ''}
                                        className="textarea-box"
                                    />
                                    <div style={{ padding: "10px" }}>
                                        <Button className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => this.onRowUpdateClick()}>SAVE</Button>
                                        <Button className="jr-btn jr-btn-sm bg-danger text-white" onClick={() => this.onRowCancelClick()}>CANCEL</Button>
                                    </div>
                                </td>
                                <td>
                                    Questions and Comments for the Client:
                                    <TextArea
                                        placeholder="Enter Questions"
                                        onChange={this.handleQuestion}
                                        value={this.state.editedData.question != null ? this.state.editedData.question : ''}
                                        className="textarea-box"
                                    />
                                </td>
                            </tr>
                        )}
                        {item.Items && item.Items.length > 0 && this.IsExpanded(item.Account) && (
                            <BSAccountsReconcileNode
                                data={item.Items}
                                level={this.state.level + 1}
                                UpdateFields={UpdateFields}
                                accountStatusChange={accountStatusChange}
                            />
                        )}
                    </React.Fragment>
                ))}
            </React.Fragment>
        );
    }
}

class BSAccountsReconcile extends Component {
    constructor(props) {
        super(props);
        this.eDateRef = React.createRef();
        this.state = {
            loading: false,
            companyId: 0,
            AsOnDate: null,
            ACMethod: "Accrual",
            lst_data: [],
            questionData: null
        };
    }

    handleFocus = (e, selecter) => {
        if (selecter !== undefined && this.eDateRef.current != null) {
            this.eDateRef.current.setFocus();
        }
    }

    handleFormChange = (e, target) => {
        if (!target) {
            this.setState({ ACMethod: e.target.value });
        }
        if (target === "AsOnDate") {
            this.setState({ AsOnDate: new Date(e) });
        }
    }

    ApplyDate = () => {
        this.setState({ loading: true }, () => {
            this.GetReportData();
        });
    }

    componentDidMount() {
        const user = JSON.parse(localStorage.getItem('userData'));
        const companyId = user.companyId;
        this.setState({ companyId, loading: true }, () => {
            this.props.GetLastQuarterGLReviewedDate(companyId);
        });
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.GLReviewLastQueterDate !== undefined && this.props.GLReviewLastQueterDate !== nextprops.GLReviewLastQueterDate) {
            if (nextprops.GLReviewLastQueterDate.transactionStatus === 0) {
                const data = nextprops.GLReviewLastQueterDate.returnObject;
                const asOn = data != null ? new Date(data) : GetLastQuarterEndDate();
                this.setState({ AsOnDate: asOn }, () => {
                    this.GetReportData();
                });
            } else {
                this.setState({ loading: false }, () => {
                    toast.error(`${nextprops.GLReviewLastQueterDate.resultMsg}`);
                });
            }
        }

        if (nextprops.BSAccountsReconcileData !== undefined && this.props.BSAccountsReconcileData !== nextprops.BSAccountsReconcileData) {
            if (nextprops.BSAccountsReconcileData.transactionStatus === 0) {
                const result = nextprops.BSAccountsReconcileData.returnObject || {};
                const accounts = result.accounts || result.Accounts || [];
                this.setState({
                    lst_data: this.MapStructuredRows(accounts),
                    loading: false
                });
            } else {
                this.setState({ loading: false, lst_data: [] }, () => {
                    toast.error(`${nextprops.BSAccountsReconcileData.resultMsg}`);
                });
            }
        }

        if (nextprops.UpdateData !== undefined && this.props.UpdateData !== nextprops.UpdateData) {
            if (nextprops.UpdateData.transactionStatus === 0) {
                if (this.state.questionData != null) {
                    this.props.AddQuestion(this.state.questionData);
                } else {
                    this.setState({ loading: false, questionData: null }, () => {
                        toast.success("Record saved successfully.");
                        this.GetReportData();
                    });
                }
            } else {
                this.setState({ loading: false }, () => {
                    toast.error(`${nextprops.UpdateData.resultMsg}`);
                });
            }
        }

        if (nextprops.AddComman !== undefined && this.props.AddComman !== nextprops.AddComman) {
            if (nextprops.AddComman.transactionStatus === 0) {
                this.setState({ loading: false, questionData: null }, () => {
                    toast.success("Record saved successfully.");
                    this.GetReportData();
                });
            } else {
                this.setState({ loading: false }, () => {
                    toast.error(`${nextprops.AddComman.resultMsg}`);
                });
            }
        }

        if (nextprops.AccountInactive !== undefined && this.props.AccountInactive !== nextprops.AccountInactive) {
            this.GetReportData();
        }
    }

    // QBO Classification drives ASSETS vs LIABILITIES AND EQUITY (future accounts land automatically).
    // AccountType is used only as a fallback when Classification is missing.
    IsAssetAccount = (item) => {
        const classification = (item.classification || item.Classification || "").toLowerCase().trim();
        if (classification === "asset") {
            return true;
        }
        if (classification === "liability" || classification === "equity") {
            return false;
        }

        const accountType = (item.accountType || item.AccountType || "").toLowerCase().trim();
        const assetTypes = [
            "bank",
            "accounts receivable",
            "other current asset",
            "fixed asset",
            "other asset"
        ];
        return assetTypes.indexOf(accountType) >= 0;
    }

    CreateHeader = (name, level) => {
        return {
            Account: name,
            IsHeader: true,
            IsSummary: false,
            IsData: false,
            IsExpandable: true,
            level: level,
            Balance: 0,
            GLBalance: 0,
            Type: "",
            Notes: "",
            Question: "",
            QuestionId: 0,
            STRT: "",
            ReconciledThrough: "",
            AccountId: 0,
            QboAccountId: 0,
            OldOutstandingCount: 0,
            Items: []
        };
    }

    CreateSummary = (name, balance, level) => {
        return {
            Account: name,
            IsHeader: false,
            IsSummary: true,
            IsData: false,
            IsExpandable: false,
            level: level,
            Balance: balance,
            GLBalance: balance,
            Type: "",
            Notes: "",
            Question: "",
            QuestionId: 0,
            STRT: "",
            ReconciledThrough: "",
            AccountId: 0,
            QboAccountId: 0,
            OldOutstandingCount: 0,
            Items: []
        };
    }

    CreateDataRow = (item, level) => {
        const balance = Number(item.balance != null ? item.balance : item.Balance) || 0;
        const reconciledThrough = item.reconciledThrough || item.ReconciledThrough || null;
        const accountType = item.accountType || item.AccountType || "";
        const accountName = item.accountNameAndNumber || item.AccountNameAndNumber
            || [item.accountNumber || item.AccountNumber, item.name || item.Name].filter(Boolean).join(" ");

        return {
            AccountId: item.accountID || item.AccountID,
            Account: accountName,
            Type: accountType,
            Balance: balance,
            GLBalance: balance,
            STRT: reconciledThrough ? moment(reconciledThrough).format("MM/DD/YYYY") : "",
            ReconciledThrough: reconciledThrough,
            Notes: item.comments || item.Comments || "",
            Question: item.question || item.Question || "",
            QuestionId: item.questionId != null ? item.questionId : item.QuestionId,
            IsData: true,
            IsHeader: false,
            IsSummary: false,
            IsExpandable: false,
            level: level,
            QboAccountId: item.listID || item.ListID,
            OldOutstandingCount: item.oldOutstandingCount || item.OldOutstandingCount || 0,
            Items: []
        };
    }

    BuildSectionTree = (sectionName, accounts, totalLabel) => {
        const section = this.CreateHeader(sectionName, 1);
        if (!accounts || accounts.length === 0) {
            return section;
        }

        const typeMap = {};
        const typeOrder = [];
        accounts.forEach((item) => {
            const accountType = item.accountType || item.AccountType || "Other";
            if (!typeMap[accountType]) {
                typeMap[accountType] = [];
                typeOrder.push(accountType);
            }
            typeMap[accountType].push(item);
        });

        let sectionTotal = 0;
        typeOrder.forEach((accountType) => {
            const typeHeader = this.CreateHeader(accountType, 2);
            let typeTotal = 0;
            typeMap[accountType].forEach((item) => {
                const row = this.CreateDataRow(item, 3);
                typeTotal += Number(row.Balance) || 0;
                typeHeader.Items.push(row);
            });
            typeHeader.Balance = typeTotal;
            typeHeader.GLBalance = typeTotal;
            typeHeader.Items.push(this.CreateSummary("Total for " + accountType, typeTotal, 2));
            section.Items.push(typeHeader);
            sectionTotal += typeTotal;
        });

        section.Balance = sectionTotal;
        section.GLBalance = sectionTotal;
        section.Items.push(this.CreateSummary(totalLabel, sectionTotal, 1));
        return section;
    }

    MapStructuredRows = (accounts) => {
        if (!accounts || accounts.length === 0) {
            return [];
        }

        const assetAccounts = [];
        const liabilityEquityAccounts = [];
        accounts.forEach((item) => {
            if (this.IsAssetAccount(item)) {
                assetAccounts.push(item);
            } else {
                liabilityEquityAccounts.push(item);
            }
        });

        const rows = [];
        if (assetAccounts.length > 0) {
            rows.push(this.BuildSectionTree("ASSETS", assetAccounts, "Total for ASSETS"));
        }
        if (liabilityEquityAccounts.length > 0) {
            rows.push(this.BuildSectionTree(
                "LIABILITIES AND EQUITY",
                liabilityEquityAccounts,
                "Total for LIABILITIES AND EQUITY"
            ));
        }
        return rows;
    }

    GetReportData = () => {
        if (this.state.AsOnDate == null) {
            this.setState({ loading: false });
            return;
        }
        const from = new Date(this.state.AsOnDate.getFullYear(), 0, 1);
        const param = "CompanyID=" + this.state.companyId
            + "&From=" + moment(from).format("MM/DD/YYYY")
            + "&To=" + moment(this.state.AsOnDate).format("MM/DD/YYYY")
            + "&AccountingMethod=" + this.state.ACMethod
            + "&Compare=false";

        this.setState({ loading: true }, () => {
            this.props.GetBSAccountsReconcile(param);
        });
    }

    UpdateFields = (data) => {
        const body = {
            accountId: data.AccountId,
            isReconciledThrough: data.isReconciledThrough,
            reconciledThrough: (data.ReconciledThrough == null || data.ReconciledThrough === "")
                ? "1970-01-01"
                : moment(data.ReconciledThrough).format("MM/DD/YYYY"),
            comments: data.Notes
        };

        const QueBody = {
            id: data.questionID != null && data.questionID !== '' ? data.questionID : 0,
            question: data.question,
            status: false,
            cpaReview: false,
            companyID: this.state.companyId,
            accountID: data.AccountId
        };

        this.setState({ loading: true, questionData: QueBody }, () => {
            this.props.UpdateCustomField(body);
        });
    }

    accountStatusChange = async (event, item) => {
        event.stopPropagation();
        if (parseInt(item.Balance, 10) !== 0 && parseFloat(item.Balance) !== 0) {
            toast.error(
                "Error - This account has a balance on your books. You may make this account inactive after the account balance is zero for all transactions."
            );
            return;
        }

        try {
            const body = {
                accountId: item.AccountId,
                isActive: false
            };
            this.setState({ loading: true });
            const response = await this.props.PUT_QuickbookAccount_UpdateAccountStatus(body);
            if (response.data.transactionStatus === 0) {
                toast.success("Account status updated successfully");
            } else if (response.data.transactionStatus === 1) {
                toast.error("This account is currently being used in a transaction.");
            }
            await this.GetReportData();
        } catch (error) {
            toast.error("Something went wrong while updating account status.");
            this.GetReportData();
        }
    }

    render() {
        const companyName = JSON.parse(localStorage.getItem('userData')) != null
            ? JSON.parse(localStorage.getItem('userData')).companyName
            : "";

        return (
            <div className="dashboardPage">
                <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h2 className="mb-3 mb-sm-0">{companyName} | {LinkType.BSAccountsReconcile}</h2>
                </div>
                <div className="padding-box app-wrapper padding-b0 bs-accounts-reconcile-filters">
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <div className="dashboard-box " style={{ flexWrap: "wrap" }}>
                                <div className="datepicker-box">
                                    <div style={{ textAlign: "left" }}> <label className="pl-2">As of :</label>
                                        <div className="date-box">
                                            <DatePicker
                                                selected={this.state.AsOnDate}
                                                onChange={(e) => this.handleFormChange(e, 'AsOnDate')}
                                                label="Loan Date"
                                                id="date"
                                                name="AsOn"
                                                margin="normal"
                                                disabledKeyboardNavigation
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                yearDropdownItemNumber={15}
                                                maxDate={getCompanyMaxDate()}
                                                ref={this.eDateRef}
                                            />
                                            <div className="date-icon" onClick={(e) => this.handleFocus(e, 'eDate')}>
                                                <i className="zmdi zmdi-calendar-note"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ textAlign: "left" }}>
                                        <label className="pl-4">A/C Method</label>
                                        <div className="date-box" style={{ padding: "0px 20px" }}>
                                            <Select
                                                name="accountingMethod"
                                                required={true}
                                                native
                                                value={this.state.ACMethod}
                                                onChange={this.handleFormChange}
                                            >
                                                <option value={""} disabled>Select Accouting Method</option>
                                                {/* <option value={"Cash"}>Cash</option> */}
                                                <option value={"Accrual"}>Accrual</option>
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                <div className="genera-apply-btn" style={{ marginTop: "10px", textAlign: "left" }}>
                                    <Button variant="contained" className="greencolor jr-btn bg-teal text-white refresh-btn" onClick={(e) => this.ApplyDate()} >Apply</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.loading ?
                    <div className="bs-accounts-reconcile-loading bs-accounts-reconcile-table-loading">
                        <CircularProgress></CircularProgress>
                    </div>
                    :
                    <div className="padding-box app-wrapper bs-accounts-reconcile-page" style={{ paddingTop: "0px" }}>
                        <div className="table-responsive-material">
                            <table className="table fixed-table">
                                <thead className="panel-bg white_header_text">
                                    <tr>
                                        <th className="width-300 bsar-account-name-col">Account No.</th>
                                        <th className="td-width type-td-width">Type</th>
                                        <th className="td-width text-center balance-td-width">Balance</th>
                                        <th className="td-width bsar-reconciled-col">Reconciled Through</th>
                                        <th className="bsar-internal-notes-col">Internal Notes</th>
                                        <th className="bsar-questions-col">Questions and Comments for the Client</th>
                                        <th className="bsar-make-inactive-col text-center">Make Inactive</th>
                                        <th className="td-width-90 text-center"><img src="/vendors/Link-arrow_header.png" alt="link" /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.lst_data.length === 0 ?
                                        <tr>
                                            <td colSpan="8" className="text-center">No Data Found!!!</td>
                                        </tr>
                                        :
                                        <BSAccountsReconcileNode
                                            key={"bsar-" + this.state.lst_data.length}
                                            data={this.state.lst_data}
                                            level={1}
                                            UpdateFields={this.UpdateFields}
                                            accountStatusChange={this.accountStatusChange}
                                        />
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        BSAccountsReconcileData: state.BalanceSheetData.BSAccountsReconcileData,
        UpdateData: state.BalanceSheetData.UpdateData,
        GLReviewLastQueterDate: state.BalanceSheetData.GLReviewLastQueterDate,
        AccountInactive: state.BalanceSheetData.AccountInactive,
        AddComman: state.QuestionCommentsData.AddComman
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GetBSAccountsReconcile,
        UpdateCustomField,
        PUT_QuickbookAccount_UpdateAccountStatus,
        GetLastQuarterGLReviewedDate,
        AddQuestion
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(BSAccountsReconcile);
